import {gql} from '@apollo/client'

export const GetUserRefCode = gql`
query {
    me {
    referrer_code
    }
    }
`
